module.exports = __webpack_public_path__ + "a8c77d2bd8a38a99e2539a2ce2aee00a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 724
// module chunks = 0